import {MutableRefObject, useEffect, useState} from 'react';
import {Dimensions, initialDimensions, sumRefDimensions} from 'src/utils/helpers';

export function useSummedRefDimensions(
  ...refs: MutableRefObject<HTMLElement | null>[]
): Dimensions {
  // forces state update when refs change
  const [dimensions, setDimensions] = useState<Dimensions>(initialDimensions);
  const currentItems = refs.map((ref) => ref.current);
  useEffect(() => {
    setDimensions(sumRefDimensions(...currentItems));
  }, currentItems);

  return dimensions;
}
